export const ORDER_GRID_TYPE = 'orders';
export const FIXTURE_GRID_TYPE = 'fixtures';
